export default __webpack_public_path__ + "static/media/patients.48aeacb4.svg";